import {Component} from '@angular/core';

@Component({
    selector: 'detail-header-action',
    imports: [],
    template: '<div class="detail-header-action-container"><ng-content/></div>',
    standalone: true,
    styles: [`
    .detail-header-action-container {
      display: flex;
      gap: 12px;
      align-items: center;
    }
  `]
})
export class DetailHeaderActionComponent {

}
